/* Kidoos — theme behaviour. No dependencies. */
(function () {
  'use strict';

  var CFG = window.KidoosConfig || {};
  var ROUTES = CFG.routes || {};
  var money = new Intl.NumberFormat(CFG.locale || 'en-GB', {
    style: 'currency',
    currency: CFG.currency || 'GBP'
  });

  function fmt(cents) { return money.format((cents || 0) / 100); }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ------------------------------------------------------------ Overlays */

  var scrim = $('#Scrim');
  var openPanel = null;
  var lastFocus = null;

  function open(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    if (openPanel && openPanel !== el) openPanel.classList.remove('is-open');
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('is-open');
    document.body.classList.add('is-locked');
    openPanel = el;
    var focusable = el.querySelector('input, button, a[href]');
    if (focusable) setTimeout(function () { focusable.focus(); }, 220);
  }

  function close() {
    if (openPanel) {
      openPanel.classList.remove('is-open');
      openPanel.setAttribute('aria-hidden', 'true');
      openPanel = null;
    }
    if (scrim) scrim.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  if (scrim) scrim.addEventListener('click', close);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openPanel) close();
  });

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      open($('#' + opener.getAttribute('data-open')));
      if (opener.getAttribute('data-open') === 'CartDrawer') refreshCart();
      return;
    }
    if (e.target.closest('[data-close]')) { e.preventDefault(); close(); }
  });

  /* -------------------------------------------------------- Sticky header */

  var header = $('#Header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ------------------------------------------------------------- The cart */

  var countEls = function () { return $$('[data-cart-count]'); };

  function setCount(n) {
    countEls().forEach(function (el) {
      el.textContent = n;
      el.hidden = n < 1;
    });
  }

  function cartLineHTML(item, index) {
    var img = item.image
      ? '<img class="cart-line__img" src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="" loading="lazy">'
      : '<div class="cart-line__img"></div>';
    var variant = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<div class="cart-line__variant">' + item.variant_title + '</div>' : '';
    return '<div class="cart-line" data-line="' + index + '">' +
      img +
      '<div>' +
        '<a class="cart-line__title" href="' + item.url + '">' + item.product_title + '</a>' +
        variant +
        '<div class="cart-line__row">' +
          '<div class="stepper">' +
            '<button type="button" data-qty="down" aria-label="Reduce quantity">&minus;</button>' +
            '<input type="number" value="' + item.quantity + '" min="0" aria-label="Quantity" data-qty-input>' +
            '<button type="button" data-qty="up" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<span class="cart-line__price">' + fmt(item.final_line_price) + '</span>' +
        '</div>' +
        '<div style="margin-top:8px"><button type="button" class="cart-remove" data-qty="remove">Remove</button></div>' +
      '</div>' +
    '</div>';
  }

  function renderCart(cart) {
    setCount(cart.item_count);

    var body = $('#CartDrawerBody');
    var foot = $('#CartDrawerFoot');
    if (!body) return;

    if (!cart.item_count) {
      body.innerHTML = '<div class="cart-empty">' +
        '<div class="cart-empty__emoji">\uD83E\uDDF8</div>' +
        '<p style="font-weight:800;margin-bottom:6px">Nothing in the basket yet</p>' +
        '<p style="color:var(--ink-soft);font-size:14px;margin-bottom:22px">Have a look around — there is bound to be something.</p>' +
        '<a class="btn" href="' + (ROUTES.all || '/collections/all') + '">Browse the toys</a>' +
      '</div>';
      if (foot) foot.hidden = true;
      return;
    }

    var threshold = CFG.freeShipping || 0;
    var progress = '';
    if (threshold > 0) {
      var left = threshold - cart.total_price;
      var pct = Math.min(100, (cart.total_price / threshold) * 100);
      progress = '<div class="cart-progress">' +
        '<div class="cart-progress__text">' +
          (left > 0 ? 'You are ' + fmt(left) + ' away from free UK delivery' : '\uD83C\uDF89 Free UK delivery unlocked') +
        '</div>' +
        '<div class="cart-progress__track"><div class="cart-progress__bar" style="width:' + pct + '%"></div></div>' +
      '</div>';
    }

    body.innerHTML = progress + cart.items.map(function (item, i) {
      return cartLineHTML(item, i + 1);
    }).join('');

    if (foot) {
      foot.hidden = false;
      foot.innerHTML = '<div class="cart-total"><span>Subtotal</span><span>' + fmt(cart.total_price) + '</span></div>' +
        '<p style="font-size:12.5px;color:var(--ink-soft);font-weight:700;margin:0 0 14px">Delivery and any discounts are worked out at checkout.</p>' +
        '<a class="btn btn--wide btn--lg" href="' + (ROUTES.checkout || '/checkout') + '">Checkout \u2192</a>' +
        '<button type="button" class="btn btn--ghost btn--wide" style="margin-top:10px" data-close>Keep shopping</button>';
    }
  }

  function refreshCart() {
    fetch((ROUTES.cart || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () { /* drawer keeps whatever it had */ });
  }

  function changeLine(line, quantity) {
    var body = $('#CartDrawerBody');
    if (body) body.style.opacity = '.5';
    fetch((ROUTES.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        if (document.body.classList.contains('template-cart')) window.location.reload();
      })
      .catch(function () { window.location.href = ROUTES.cart || '/cart'; })
      .then(function () { if (body) body.style.opacity = ''; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var wrap = btn.closest('[data-line]');
    if (!wrap) return;
    e.preventDefault();

    var line = parseInt(wrap.getAttribute('data-line'), 10);
    var input = wrap.querySelector('[data-qty-input]');
    var current = input ? parseInt(input.value, 10) : 1;
    var action = btn.getAttribute('data-qty');

    if (action === 'remove') changeLine(line, 0);
    else if (action === 'up') changeLine(line, current + 1);
    else if (action === 'down') changeLine(line, Math.max(0, current - 1));
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    var wrap = input.closest('[data-line]');
    if (!wrap) return;
    changeLine(parseInt(wrap.getAttribute('data-line'), 10), Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* ---------------------------------------------------------- Add to cart */

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action$="/cart/add"]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    if (btn && btn.dataset.busy === '1') return;
    var label = btn ? (btn.dataset.label || btn.textContent) : '';
    if (btn) {
      btn.dataset.label = label;
      btn.dataset.busy = '1';
      btn.textContent = 'Adding\u2026';
      btn.disabled = true;
    }

    function restore(text) {
      if (!btn) return;
      btn.textContent = text || label;
      btn.disabled = false;
      btn.dataset.busy = '0';
    }

    fetch((ROUTES.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () {
        restore('Added \u2713');
        setTimeout(function () { restore(label); }, 1400);
        refreshCart();
        open($('#CartDrawer'));
      })
      .catch(function (err) {
        restore(label);
        var msg = (err && err.description) ? err.description : 'Sorry, that could not be added.';
        var slot = form.querySelector('[data-form-error]');
        if (slot) { slot.textContent = msg; slot.hidden = false; }
        else window.alert(msg);
      });
  });

  /* --------------------------------------------------------- Plain steppers
     (product page quantity — not tied to a cart line) */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-step]');
    if (!btn) return;
    e.preventDefault();
    var input = btn.parentElement.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    input.value = btn.getAttribute('data-step') === 'up' ? val + 1 : Math.max(1, val - 1);
  });

  /* ------------------------------------------------------- Product gallery */

  $$('[data-gallery]').forEach(function (gal) {
    var main = gal.querySelector('[data-gallery-main]');
    gal.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-gallery-thumb]');
      if (!thumb || !main) return;
      main.src = thumb.getAttribute('data-full');
      main.alt = thumb.getAttribute('data-alt') || '';
      gal.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
        t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
      });
    });
  });

  /* -------------------------------------------------------- Variant picker */

  $$('[data-variants]').forEach(function (root) {
    var data;
    try { data = JSON.parse(root.querySelector('[data-variant-json]').textContent); }
    catch (err) { return; }

    var idInput = root.querySelector('[data-variant-id]');
    var priceNow = root.querySelector('[data-price-now]');
    var priceWas = root.querySelector('[data-price-was]');
    var priceOff = root.querySelector('[data-price-off]');
    var addBtn = root.querySelector('[data-add-btn]');

    function selected() {
      return $$('[data-opt-group]', root).map(function (group) {
        var chip = group.querySelector('.opt__chip.is-selected');
        return chip ? chip.getAttribute('data-value') : null;
      });
    }

    function match(values) {
      return data.find(function (v) {
        return values.every(function (val, i) { return v.options[i] === val; });
      });
    }

    function paint() {
      var values = selected();
      var variant = match(values);

      $$('[data-opt-group]', root).forEach(function (group, gi) {
        var out = group.querySelector('[data-opt-current]');
        if (out) out.textContent = values[gi] || '';
        group.querySelectorAll('.opt__chip').forEach(function (chip) {
          var probe = values.slice();
          probe[gi] = chip.getAttribute('data-value');
          var candidate = match(probe);
          chip.classList.toggle('is-unavailable', !candidate || !candidate.available);
        });
      });

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceNow) priceNow.textContent = fmt(variant.price);

      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (priceWas) {
        priceWas.hidden = !onSale;
        if (onSale) priceWas.textContent = fmt(variant.compare_at_price);
      }
      if (priceOff) {
        priceOff.hidden = !onSale;
        if (onSale) {
          priceOff.textContent = 'Save ' + Math.round((1 - variant.price / variant.compare_at_price) * 100) + '%';
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to basket' : 'Sold out';
        addBtn.dataset.label = addBtn.textContent;
      }

      if (history.replaceState && variant.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('click', function (e) {
      var chip = e.target.closest('.opt__chip');
      if (!chip) return;
      e.preventDefault();
      chip.closest('[data-opt-group]').querySelectorAll('.opt__chip').forEach(function (c) {
        c.classList.remove('is-selected');
        c.setAttribute('aria-pressed', 'false');
      });
      chip.classList.add('is-selected');
      chip.setAttribute('aria-pressed', 'true');
      paint();
    });

    paint();
  });

  /* ------------------------------------------------------------ Accordions */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.acc__btn');
    if (!btn) return;
    var isOpen = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!isOpen));
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (panel) panel.classList.toggle('is-open', !isOpen);
  });

  /* ------------------------------------------------- Tidy the description
     Imported supplier descriptions arrive full of stacked photos, spec
     tables and empty paragraphs. Strip them, then clamp what is left so the
     page opens with something a parent can actually read. */

  (function tidyDescription() {
    var el = document.getElementById('AccDesc');
    if (!el) return;

    el.querySelectorAll('img, table, iframe, video, script, style, noscript')
      .forEach(function (node) { node.remove(); });

    el.querySelectorAll('p, div, span').forEach(function (node) {
      if (!node.textContent.trim() && !node.querySelector('img, br')) node.remove();
    });

    var limit = parseInt(el.getAttribute('data-clamp'), 10);
    if (!limit || el.textContent.trim().length <= limit) return;

    var blocks = Array.prototype.slice.call(el.children);
    if (!blocks.length) return;

    var running = 0;
    var hidden = [];
    blocks.forEach(function (node) {
      if (running >= limit) { node.hidden = true; hidden.push(node); }
      running += node.textContent.length;
    });
    if (!hidden.length) return;

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'link-arrow';
    toggle.style.marginTop = '10px';
    toggle.style.background = 'none';
    toggle.style.border = '0';
    toggle.style.padding = '0';
    toggle.style.cursor = 'pointer';
    toggle.textContent = 'Read the full description';
    toggle.addEventListener('click', function () {
      var showing = hidden[0].hidden === false;
      hidden.forEach(function (node) { node.hidden = showing; });
      toggle.textContent = showing ? 'Read the full description' : 'Show less';
    });
    el.appendChild(toggle);
  })();

  /* -------------------------------------------------------------- Hotspots */

  document.addEventListener('click', function (e) {
    var dot = e.target.closest('.hotspot__dot');
    var inCard = e.target.closest('.hotspot__card');
    if (inCard) return;
    $$('.hotspot.is-open').forEach(function (h) {
      if (!dot || h !== dot.closest('.hotspot')) {
        h.classList.remove('is-open');
        var d = h.querySelector('.hotspot__dot');
        if (d) d.setAttribute('aria-expanded', 'false');
      }
    });
    if (dot) {
      var spot = dot.closest('.hotspot');
      var now = spot.classList.toggle('is-open');
      dot.setAttribute('aria-expanded', String(now));
    }
  });

  /* -------------------------------------------------- Predictive search */

  var searchInput = $('#SearchInput');
  var searchResults = $('#SearchResults');
  if (searchInput && searchResults) {
    var timer;
    searchInput.addEventListener('input', function () {
      clearTimeout(timer);
      var q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch((ROUTES.predictive || '/search/suggest.json') +
              '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (json) {
            var items = (json.resources && json.resources.results && json.resources.results.products) || [];
            if (!items.length) {
              searchResults.innerHTML = '<li style="padding:16px 0;font-weight:700;color:var(--ink-soft)">Nothing matched \u201C' + q + '\u201D.</li>';
              return;
            }
            searchResults.innerHTML = items.map(function (p) {
              var img = p.featured_image && p.featured_image.url
                ? '<img src="' + p.featured_image.url + '" alt="" loading="lazy">' : '<img alt="">';
              return '<li><a href="' + p.url + '">' + img +
                '<span><strong>' + p.title + '</strong><span>' + (p.price ? fmt(p.price) : '') + '</span></span></a></li>';
            }).join('');
          })
          .catch(function () { searchResults.innerHTML = ''; });
      }, 220);
    });
  }

  /* ---------------------------------------------------------- Scroll reveal */

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* --------------------------------------------------------- Sort dropdown */

  $$('[data-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  refreshCart();
})();
